export default function classNames(...names: string[]) {
    return names.filter(Boolean).join(' ');
}
